import { fetcherNew1819 } from "@utils/fetcherNew1819";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import useUser from "./use_user";
import ability from "@utils/ability";

export const usePostalCodes = () => {
    return useSWR("mitt/postal-codes", fetcherNew1819);
};

export const useMunicipalities = () => {
    return useSWR("mitt/municipalities", fetcherNew1819);
};

export const useSmsUsers = (includeDeleted) => {
    if (includeDeleted) {
        return useSWR("mitt/sms/users?include-deleted=true", fetcherNew1819);
    }
    return useSWR("mitt/sms/users", fetcherNew1819);
};

export const useAnsweringCompanies = () => {
    return useSWR("mitt/answering/companies", fetcherNew1819);
};

export const useAnsweringCompanyUsers = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/answering/company/${id}/users`, fetcherNew1819);
};

export const useArchivedAnsweringCompanies = () => {
    return useSWR("mitt/answering/companies/archived", fetcherNew1819);
};

export const useEmployees = () => {
    return useSWR("mitt/employees", fetcherNew1819);
};

export const useSvarBilling = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/billing/svar/?month=${month}`, fetcherNew1819);
};

export const useRenamePeople = () => {
    return useSWR("mitt/project/rename-people", fetcherNew1819);
};

export const useBillingAnswerCompanies = (startDay, endDay, startTime, endTime) => {
    return useSWR(
        `mitt/billing/answer-companies?start-day=${startDay}&end-day=${endDay}&start-time=${startTime}&end-time=${endTime}`,
        fetcherNew1819,
    );
};

export const useBillingChat = (companyID, startDay, endDay, startTime, endTime) => {
    return useSWR(
        `mitt/billing/chat/${companyID}?start-day=${startDay}&end-day=${endDay}&start-time=${startTime}&end-time=${endTime}`,
        fetcherNew1819,
    );
};

export const useBillingChatCompanies = () => {
    return useSWR("mitt/billing/chat", fetcherNew1819);
};

export const useBillingThjonustuver = (startDay, endDay) => {
    return useSWR(
        `mitt/billing/thjonustuver?start-day=${startDay}&end-day=${endDay}`,
        fetcherNew1819,
    );
};

export const useAnsweringCompany = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/answering/company?id=${id}`, fetcherNew1819);
};

export const useBillingSms = (startDay, endDay) => {
    return useSWR(`mitt/billing/sms?start-day=${startDay}&end-day=${endDay}`, fetcherNew1819);
};
export const useBillingSmsNew = (startDay, endDay) => {
    return useSWR(`mitt/billing/sms/new?start-day=${startDay}&end-day=${endDay}`, fetcherNew1819);
};

export const useBillingApi = (startDay, endDay) => {
    return useSWR(`mitt/billing/api?start-day=${startDay}&end-day=${endDay}`, fetcherNew1819);
};
export const useNewBillingApi = (startDay, endDay) => {
    return useSWR(`mitt/billing/api/new?start-day=${startDay}&end-day=${endDay}`, fetcherNew1819);
};
export const useRegistrationLog = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/registration/${id}/log`, fetcherNew1819);
};

export const useSearchWords = (id, startDay, endDay) => {
    if (!id) return useSWRImmutable(null, fetcherNew1819);
    return useSWRImmutable(
        `mitt/registration/${id}/search-words?start-day=${startDay}&end-day=${endDay}`,
        fetcherNew1819,
    );
};

export const useMySmsAccounts = () => {
    return useSWR("mitt/sms/user", fetcherNew1819);
};

export const useRegistrationStatistics = (startDay, endDay) => {
    if (startDay && endDay) {
        return useSWR(
            `mitt/statistics/registrations?start-day=${startDay}&end-day=${endDay}`,
            fetcherNew1819,
        );
    }
    return useSWR("mitt/statistics/registrations", fetcherNew1819);
};

export const useSearchStatistics = (startDay, endDay) => {
    if (startDay && endDay) {
        return useSWR(
            `mitt/statistics/search?start-day=${startDay}&end-day=${endDay}`,
            fetcherNew1819,
        );
    }
    return useSWR("mitt/statistics/search", fetcherNew1819);
};

export const useSmsStatistics = (startDay, endDay) => {
    if (startDay && endDay) {
        return useSWR(
            `mitt/statistics/sms?start-day=${startDay}&end-day=${endDay}`,
            fetcherNew1819,
        );
    }
    return useSWR("mitt/statistics/sms", fetcherNew1819);
};

export const useThjodskraStatistics = () => {
    return useSWR("mitt/statistics/thjodskra", fetcherNew1819);
};

export const useThjonustuverStatistics = (startDay, endDay, user_extension) => {
    if (user_extension === undefined) user_extension = "";
    return useSWR(
        `mitt/statistics/thjonustuver?start-day=${startDay}&end-day=${endDay}&user-extension=${user_extension}`,
        fetcherNew1819,
    );
};

export const useQueueStatistics = (startDay, endDay, companyID, interval) => {
    if (companyID === undefined) companyID = "";
    if (interval === undefined) interval = "day";
    return useSWRImmutable(
        `mitt/answering/company/${companyID}/statistics?start-day=${startDay}&end-day=${endDay}&interval=${interval}`,
        fetcherNew1819,
    );
};

export const useQueueCalls = (startDay, endDay, companyID) => {
    if (!companyID) return useSWRImmutable(null, fetcherNew1819);
    return useSWRImmutable(
        `mitt/answering/company/${companyID}/statistics/calls?start-day=${startDay}&end-day=${endDay}`,
        fetcherNew1819,
    );
};

export const useAgentExtensions = (startDay, endDay) => {
    return useSWR(
        `mitt/statistics/thjonustuver/agent-extensions?start-day=${startDay}&end-day=${endDay}`,
        fetcherNew1819,
    );
};

export const useRoles = () => {
    return useSWR("mitt/roles", fetcherNew1819);
};

export const useApiClients = () => {
    return useSWR("mitt/api-clients", fetcherNew1819);
};

export const useCities = () => {
    return useSWR("mitt/postal-code/cities", fetcherNew1819);
};
export const useAllowedCities = () => {
    return useSWR("mitt/sms/user/cities", fetcherNew1819);
};

export const useCityPostalCodes = (city) => {
    return useSWRImmutable(`mitt/postal-code/city-postal-codes?city=${city}`, fetcherNew1819);
};
export const useStreets = (city, postalCode) => {
    let url = `mitt/postal-code/streets?city=${city}`;
    if (postalCode !== undefined && postalCode !== null && postalCode !== "all")
        url += `&postal-code=${postalCode}`;
    if (city === undefined) url = null;
    if (city === null) url = null;
    if (city === "") url = null;
    return useSWR(url, fetcherNew1819);
};

export const useSmsPhoneLists = () => {
    return useSWR("mitt/sms/user/phone-lists", fetcherNew1819);
};

export const useSmsPhoneList = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/sms/user/phone-lists/${id}`, fetcherNew1819);
};

export const useSentMessages = (page = 1, limit = 50) => {
    const safePage = page ?? 1;
    const safeLimit = Math.min(limit ?? 50, 200);
    return useSWR(`mitt/sms/user/messages?page=${safePage}&limit=${safeLimit}`, fetcherNew1819);
};

// Án pagination til að sækja alltaf tímasett skilaboð óháð síðu
export const useScheduledMessages = () => {
    return useSWR("mitt/sms/user/messages/scheduled", fetcherNew1819);
};

export const useSmsUsage = (smsUserId) => {
    if (!smsUserId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/sms/user/usage?sms_user_id=${smsUserId}`, fetcherNew1819);
};

export const useSentMessageDetails = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/sms/user/messages/${id}`, fetcherNew1819);
};

export const usePhoneCompanyUpdates = () => {
    return useSWR("mitt/phone-company-updates", fetcherNew1819);
};

export const useSearchPhoneCompanyUpdates = (phone) => {
    if (!phone) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/phone-company-updates/${phone}`, fetcherNew1819);
};

export const useNewCompanies = () => {
    return useSWR("mitt/new-companies", fetcherNew1819);
};

export const useAdvertisementByKennitala = (kennitala, startDay, endDay) => {
    return useSWR(
        `mitt/advertisements/kennitala/${kennitala}?start-day=${startDay}&end-day=${endDay}`,
        fetcherNew1819,
        {
            keepPreviousData: true,
        },
    );
};

export const useHubspotInboxes = () => {
    return useSWR("mitt/answering/inboxes", fetcherNew1819);
};

export const usePackages = () => {
    const user = useUser();
    if (ability(user).cannot("read", "subscriptions")) return useSWR(null, fetcherNew1819);
    return useSWR("mitt/subscriptions", fetcherNew1819);
};

export const usePackage = (id) => {
    if (id === null || id === undefined) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/subscriptions/${id}`, fetcherNew1819);
};

export const useAddressSuggestions = (query) => {
    if (query === null || query === undefined || query === "") return useSWR(null, fetcherNew1819);
    return useSWRImmutable(`mitt/stadfangaskra?q=${query}`, fetcherNew1819);
};

export const useCompanySuggestions = (query, includeUnregistered) => {
    if (query === null || query === undefined) return useSWR(null, fetcherNew1819);
    if (includeUnregistered) {
        return useSWR(`mitt/companies/search?q=${query}&include-unregistered=true`, fetcherNew1819);
    }
    return useSWR(`mitt/companies/search?q=${query}`, fetcherNew1819);
};

export const useAddressRequests = () => {
    return useSWR("mitt/address-request", fetcherNew1819);
};

export const useCompanyRequests = () => {
    return useSWR("mitt/company-request", fetcherNew1819);
};

export const useCallCenterComments = () => {
    return useSWR("mitt/thjonustuver/comments", fetcherNew1819);
};

export const useCallCenterComment = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/thjonustuver/comments/${id}`, fetcherNew1819);
};

export const useZenterRequests = () => {
    return useSWR("mitt/zenter-requests", fetcherNew1819);
};

export const useAiSuggestions = (status, type) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (type) params.append("type", type);
    const query = params.toString();
    return useSWR(`mitt/ai-suggestions${query ? `?${query}` : ""}`, fetcherNew1819);
};

export const useAiSuggestionsByRegistration = (regId) => {
    return useSWR(
        regId ? `mitt/ai-suggestions?registration_id=${regId}&include_current_data=true` : null,
        fetcherNew1819
    );
};

export const useZenterRequest = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/zenter-requests/${id}`, fetcherNew1819);
};

export const useZenterRequestCount = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/zenter-requests/${id}/count`, fetcherNew1819);
};

export const useCompanyAccess = () => {
    return useSWR("mitt/company-access", fetcherNew1819);
};

export const useCompanyUsers = (kennitala) => {
    return useSWR(`mitt/company-access/${kennitala}`, fetcherNew1819);
};

export const useListavinnsla = () => {
    return useSWR("mitt/listavinnsla", fetcherNew1819);
};

export const useListavinnslaList = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/listavinnsla/${id}`, fetcherNew1819);
};

export const useListavinnslaListCount = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/listavinnsla/${id}/count`, fetcherNew1819);
};

export const usePhoneCallsTodayForNumber = (number) => {
    return useSWR(`mitt/statistics/thjonustuver/phone-today/${number}`, fetcherNew1819);
};

export const usePhoneCalls3MonthsForNumber = (number) => {
    return useSWR(`mitt/statistics/thjonustuver/phone-3months/${number}`, fetcherNew1819);
};

export const useStatus = () => {
    // Only fetch if user is logged in
    const user = useUser();

    if (!user) {
        return useSWR(null, fetcherNew1819);
    }

    return useSWR("mitt/status", fetcherNew1819);
};

export const useListavinnslaCategories = () => {
    return useSWR("mitt/listavinnsla/categories", fetcherNew1819);
};

export const useAdvertisements = () => {
    return useSWR("mitt/advertisements", fetcherNew1819);
};

export const useAdvertisementStatistics = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/advertisements/${id}/statistics`, fetcherNew1819);
};

export const useCallCampaigns = () => {
    return useSWR("mitt/call-campaigns", fetcherNew1819);
};

export const useMyCallCampaigns = () => {
    return useSWR("mitt/call-campaigns/my", fetcherNew1819);
};

export const useCallCampaign = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}`, fetcherNew1819);
};

export const useCallCampaignLists = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    if (id === "nytt") return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/lists`, fetcherNew1819);
};

export const useCurrentRecipient = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/current-recipient`, fetcherNew1819);
};

export const useCallCampaignStatistics = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/statistics`, fetcherNew1819, {
        refreshInterval: 10000,
    });
};

export const useCallCampaignAttemptHistory = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/attempt-history`, fetcherNew1819, {
        refreshInterval: 10000,
    });
};

export const useCallCampaignAssignedRecipients = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/assigned-recipients`, fetcherNew1819);
};

export const useCallCampaignListItemResults = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/call-campaigns/${id}/list-item-results`, fetcherNew1819);
};

export const useMonthlyInvoices = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice/month/${month}`, fetcherNew1819);
};

export const useMonthlySmsInvoices = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice/month/${month}/sms`, fetcherNew1819, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useMonthlyApiInvoices = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice/month/${month}/api`, fetcherNew1819, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useMonthlyAnsweringInvoices = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice/month/${month}/answering`, fetcherNew1819, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useMonthly1819Invoices = (month) => {
    if (!month) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice/month/${month}/1819`, fetcherNew1819, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useRegistrationAccess = (registrationId) => {
    if (!registrationId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/registration/${registrationId}/access`, fetcherNew1819);
};

export const useRegistrationAccessUsers = (registrationId) => {
    if (!registrationId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/registration/${registrationId}/access/users`, fetcherNew1819);
};

export const useGames = () => {
    return useSWR("mitt/games", fetcherNew1819);
};

export const useGame = (gameId) => {
    if (!gameId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/games/${gameId}`, fetcherNew1819);
};

export const useGameInitials = (gameId, options = {}) => {
    if (!gameId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/game/${gameId}/initials`, fetcherNew1819, options);
};

export const useGameRegistration = (gameId, initial, options = {}) => {
    if (!gameId) return useSWR(null, fetcherNew1819);
    if (!initial) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/game/${gameId}/${initial}?limit=20`, fetcherNew1819, options);
};

export const useGameRegistrationDetail = (gameId, regId) => {
    if (!gameId || !regId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/game/${gameId}/registrations/${regId}`, fetcherNew1819);
};

export const useRegistrationCategories = () => {
    return useSWR("mitt/registration/categories", fetcherNew1819);
};

// Nýskráningar fyrirtækja fyrir leik með síðum
export const useGameNewlyRegisteredCompanies = (gameId, page = 1, pageSize = 50, days = 365) => {
    if (!gameId) return useSWR(null, fetcherNew1819);
    const params = new URLSearchParams({
        page: String(page),
        page_size: String(pageSize),
        days: String(days),
    }).toString();
    return useSWR(`mitt/game/${gameId}/nyskraning?${params}`, fetcherNew1819);
};

export const useRedirects = () => {
    return useSWR("mitt/redirect", fetcherNew1819);
};

export const useInvoiceSettings = () => {
    return useSWR("mitt/invoice-settings", fetcherNew1819);
};

export const useInvoiceSettingsByKennitala = (kennitala) => {
    if (!kennitala) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/invoice-settings/kennitala/${kennitala}`, fetcherNew1819);
};

export const useZendeskUnassignedTickets = () => {
    return useSWR("mitt/zendesk/unassigned-tickets/summary", fetcherNew1819, {
        refreshInterval: 30000,
    });
};

// Game registration list management
export const useGameListStats = (gameId, options = {}) => {
    if (!gameId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/game/${gameId}/list-stats`, fetcherNew1819, {
        refreshInterval: 30000, // Uppfæra á 30 sekúndna fresti
        ...options,
    });
};

// --- SPJALLMENNI (CHATBOT ADMIN) ---
export const useChatbotConfig = (companyId) => {
    if (!companyId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/chatbot/${companyId}/config`, fetcherNew1819);
};

export const useChatbotOverrides = (companyId) => {
    if (!companyId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/chatbot/${companyId}/overrides`, fetcherNew1819);
};

// --- SPJALLMENNI: VIRK SPJÖLL & HANDOFF (U5) ---
// Rauntíma um SWR-pollun (fetcherNew1819 sér um JWT). EventSource styður ekki JWT-haus.
export const useActiveChats = (companyId, { refreshInterval = 3000 } = {}) => {
    if (!companyId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/chatbot/${companyId}/conversations`, fetcherNew1819, {
        refreshInterval,
    });
};

// Þvers-fyrirtækja: öll virk spjöll (fyrir þjónustuver/símsvörun).
export const useAllActiveChats = ({ enabled = true, refreshInterval = 3000 } = {}) => {
    return useSWR(enabled ? `mitt/chatbot/conversations/active` : null, fetcherNew1819, {
        refreshInterval,
    });
};

export const useConversation = (companyId, conversationId, { refreshInterval = 2000 } = {}) => {
    if (!companyId || !conversationId) return useSWR(null, fetcherNew1819);
    return useSWR(`mitt/chatbot/${companyId}/conversations/${conversationId}`, fetcherNew1819, {
        refreshInterval,
    });
};

// Aðgerðir (POST) — skila niðurstöðu; kallandi sér um að revalidate-a SWR.
export const claimConversation = (companyId, conversationId) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/claim`, "POST");

export const takeoverConversation = (companyId, conversationId) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/takeover`, "POST");

export const sendAgentMessage = (companyId, conversationId, content) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/messages`, "POST", {
        content,
    });

export const sendAgentTyping = (companyId, conversationId, on) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/typing`, "POST", {
        on,
    });

export const markConversationRead = (companyId, conversationId, messageIds) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/read`, "POST", {
        messageIds,
    });

export const closeConversation = (companyId, conversationId) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/close`, "POST");

// --- SPJALLMENNI: FEEDBACK & ANALYTICS (U7) ---
export const useChatbotAnalytics = (companyId, from, to) => {
    if (!companyId) return useSWR(null, fetcherNew1819);
    const params = new URLSearchParams();
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    const qs = params.toString();
    return useSWR(`mitt/chatbot/${companyId}/analytics${qs ? `?${qs}` : ""}`, fetcherNew1819);
};

export const useChatbotHistory = (companyId, filters = {}) => {
    if (!companyId) return useSWR(null, fetcherNew1819);
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") params.set(k, v);
    });
    const qs = params.toString();
    return useSWR(
        `mitt/chatbot/${companyId}/conversations/history${qs ? `?${qs}` : ""}`,
        fetcherNew1819,
        { keepPreviousData: true },
    );
};

export const useChatbotTranscript = (companyId, conversationId) => {
    if (!companyId || !conversationId) return useSWR(null, fetcherNew1819);
    return useSWR(
        `mitt/chatbot/${companyId}/conversations/${conversationId}/transcript`,
        fetcherNew1819,
    );
};

export const purgeConversation = (companyId, conversationId) =>
    fetcherNew1819(`mitt/chatbot/${companyId}/conversations/${conversationId}/purge`, "POST");
